import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconThunder: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconThunder"><Path d="M15.2029 0.216309L2.89844 15.0001H10.0936L8.79396 23.7838L21.0985 9.00007H13.9033L15.2029 0.216309Z" fill="currentColor"/></CentralIconBase>;
});

export default IconThunder;
